export default function RolesFactory() {
    var fn = this;

    /**
     * userHasOneOfThesesRoles
     * @param {array of int} ids //converts to array internally
     * @param {obj} userRoles
     * @return Bool
     */

    fn.userHasOneOfThesesRoles = (ids, roleId) => {
        ids = Array.isArray(ids) ? ids : [ids]; // ensure array

        return ids.indexOf(parseInt(roleId)) !== -1;
    };

    return fn;
}
